import { render, staticRenderFns } from "./HomeHow.vue?vue&type=template&id=6665d799&scoped=true&"
import script from "./HomeHow.vue?vue&type=script&lang=js&"
export * from "./HomeHow.vue?vue&type=script&lang=js&"
import style0 from "./HomeHow.vue?vue&type=style&index=0&id=6665d799&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6665d799",
  null
  
)

export default component.exports